import { RootState } from 'redux/reducers/rootReducer';

export const isTemplateFormDirtySelector = (state: RootState) =>
  state.template.isTemplateFormDirty;
